"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const mobileProfileState_1 = __importDefault(require("./mobileProfileState"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const material_1 = require("@mui/material");
const BottomNavigation_1 = __importDefault(require("@mui/material/BottomNavigation"));
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1() {
    const { has_new, profile_img_url } = (0, recoil_1.useRecoilValue)(mobileProfileState_1.default);
    const [value, setValue] = (0, react_1.useState)(window.location.pathname);
    const [open, setOpen] = (0, react_1.useState)(false);
    const handleChange = (event, newValue) => {
        setValue(window.location.pathname);
        window.location.href = newValue;
    };
    const maxWidth768 = (0, material_1.useMediaQuery)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(BottomNavigation_1.default, Object.assign({ className: "mui-fixed", sx: {
            position: 'fixed',
            bottom: '0',
            display: maxWidth768 ? 'flex' : 'none',
            height: '53px',
            width: '100%',
            backgroundColor: 'white',
            filter: 'drop-shadow(0px -1px 4px rgba(0, 0, 0, 0.1))',
            zIndex: '100',
        }, value: value, showLabels: true, onChange: handleChange }, { children: [(0, jsx_runtime_1.jsx)(material_1.BottomNavigationAction, { sx: bottomNavProfileSx, label: t('홈'), value: "/", icon: (0, jsx_runtime_1.jsx)(svgs_1.NavRoomSvg, {}) }), (0, jsx_runtime_1.jsx)(material_1.BottomNavigationAction, { sx: bottomNavProfileSx, label: t('N-구독'), value: "/room/feed-new/", icon: (0, jsx_runtime_1.jsx)(svgs_1.NavSubscribeSvg, {}) }), (0, jsx_runtime_1.jsx)(material_1.BottomNavigationAction, { sx: bottomNavProfileSx, label: t('구매내역'), value: "/order/history", icon: (0, jsx_runtime_1.jsx)(svgs_1.NavOrderHistorySvg, {}) }), (0, jsx_runtime_1.jsx)(CreateButtonWrapper, { children: (0, jsx_runtime_1.jsxs)(material_1.Button, Object.assign({ fullWidth: true, onClick: () => setOpen(true) }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.PlusOrangeCircleWhiteOutlinedSvg, {}), (0, jsx_runtime_1.jsx)("span", { children: t('판매시작') })] })) }), (0, jsx_runtime_1.jsx)(material_1.BottomNavigationAction, { sx: bottomNavProfileSx, label: t('판매내역'), value: "/room/history", icon: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(svgs_1.NavRoomHistorySvg, {}), has_new && ((0, jsx_runtime_1.jsx)(svgs_1.NewIconSvg, { css: { position: 'absolute', top: '6px', left: '50%', stroke: 'none' } }))] }) }), (0, jsx_runtime_1.jsxs)(ProfileWrapper, Object.assign({ onClick: () => {
                    if (window.location.pathname !== '/member/menu') {
                        window.location.href = '/member/menu';
                    }
                } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.NavProfileFrameSvg, {}), (0, jsx_runtime_1.jsx)("div", Object.assign({ id: "mobile_profile" }, { children: (0, jsx_runtime_1.jsx)("img", { src: (0, functions_1.getCdnUrl)(profile_img_url) || '/static/homepage/img/nav_profile.svg', css: {
                                width: '100%',
                                height: '100%',
                                borderRadius: '50%',
                                objectFit: 'cover',
                            } }) }))] })), (0, jsx_runtime_1.jsx)(_1.CreateDialog, { open: open, setOpen: setOpen })] })));
}
exports.default = default_1;
const bottomNavProfileSx = {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    rowGap: '7px',
    minWidth: 0,
    p: '0 !important',
    border: '0',
    color: 'black',
    stroke: 'black',
    strokeWidth: '1.5',
    '&.Mui-selected': {
        color: 'var(--primary-dark)',
        stroke: 'var(--primary-dark)',
    },
    '.MuiBottomNavigationAction-label': {
        lineHeight: '14px',
        fontSize: '12px !important',
        color: 'var(--gray-80)',
    },
};
const ProfileWrapper = styled_1.default.div `
  margin-top: -10px;
  position: relative;
  cursor: pointer;

  #mobile_profile {
    position: absolute;
    top: 4px;
    left: calc(50% - 24px);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px;
    overflow: hidden;
  }
`;
const CreateButtonWrapper = styled_1.default.div `
  flex: 1;
  display: flex;
  min-width: 54px;
  max-width: 90px;
  button {
    flex-direction: column;
    row-gap: 3px;
    padding: 0;
    border-radius: 0;
    background-color: var(--white) !important;
    color: var(--gray-80);
    line-height: 14px;
    font-size: 12px;
  }
`;
